export default __webpack_public_path__ + "static/media/play2.2df842c3.svg";